export const getIngredientsState = state => state.ingredients
export const getUserState = state => state.user
export const getBurgerConstructorState = state => state.burgerConstructor
